/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MedicaidCasePresetCounts
 */
export interface MedicaidCasePresetCounts {
    /**
     * 
     */
    needs_action: number;
    /**
     * 
     */
    assigned_to_me: number;
    /**
     * 
     */
    closed: number;
    /**
     * 
     */
    all: number;
}

/**
 * Check if a given object implements the MedicaidCasePresetCounts interface.
 */
export function instanceOfMedicaidCasePresetCounts(value: object): value is MedicaidCasePresetCounts {
    if (!('needs_action' in value) || value['needs_action'] === undefined) return false;
    if (!('assigned_to_me' in value) || value['assigned_to_me'] === undefined) return false;
    if (!('closed' in value) || value['closed'] === undefined) return false;
    if (!('all' in value) || value['all'] === undefined) return false;
    return true;
}

export function MedicaidCasePresetCountsFromJSON(json: any): MedicaidCasePresetCounts {
    return MedicaidCasePresetCountsFromJSONTyped(json, false);
}

export function MedicaidCasePresetCountsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicaidCasePresetCounts {
    if (json == null) {
        return json;
    }
    return {
        
        'needs_action': json['needs_action'],
        'assigned_to_me': json['assigned_to_me'],
        'closed': json['closed'],
        'all': json['all'],
    };
}

export function MedicaidCasePresetCountsToJSON(json: any): MedicaidCasePresetCounts {
    return MedicaidCasePresetCountsToJSONTyped(json, false);
}

export function MedicaidCasePresetCountsToJSONTyped(value?: MedicaidCasePresetCounts | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'needs_action': value['needs_action'],
        'assigned_to_me': value['assigned_to_me'],
        'closed': value['closed'],
        'all': value['all'],
    };
}

